import {button,escapeHtml,message} from '../ui/components.js';

const LABELS=Object.freeze({
  smoking_session:'sesja',
  smoking_item:'produkt',
  smoking_stage:'etap',
  stage_target:'cele etapu',
  stage_item_target:'cel produktu',
  session_wood:'mieszanka drewna',
  item_preparation:'przygotowanie produktu',
  journal_session_note:'notatka sesji',
  journal_item_note:'notatka produktu',
  temperature_reading:'odczyt temperatury',
  live_event:'zdarzenie Live',
  live_note:'notatka Live',
  live_stage_transition:'zmiana etapu Live'
});

export function journalSyncStatusMarkup({conflicts=[]}={}){
  if(!(conflicts||[]).length)return '';
  const rows=conflicts||[];
  const items=rows.map(conflict=>{
    const label=LABELS[conflict.entityType]||'zmiana';
    const reason=String(conflict?.conflict?.reason||'version_mismatch');
    return '<li><strong>'+escapeHtml(label)+'</strong> · '+escapeHtml(reason)+'</li>';
  }).join('');

  const sessionConflicts=new Map(
    rows
      .filter(conflict=>conflict.entityType==='smoking_session')
      .map(conflict=>[String(conflict.sessionId||conflict.id),conflict])
  );
  const dependentSessions=new Set(
    rows
      .filter(conflict=>conflict?.conflict?.reason==='parent_session_conflict')
      .map(conflict=>String(conflict.sessionId||''))
      .filter(Boolean)
  );

  const actions=[];
  for(const sessionId of sessionConflicts.keys()){
    actions.push(button({
      label:'Przyjmij stan z serwera',
      variant:'secondary',
      attributes:{'data-journal-session-conflict-refresh':sessionId}
    }));
  }
  for(const sessionId of dependentSessions){
    if(sessionConflicts.has(sessionId))continue;
    actions.push(button({
      label:'Odrzuć lokalną zmianę etapu',
      variant:'danger',
      attributes:{'data-journal-stage-conflicts-discard':sessionId}
    }));
  }

  return '<section class="journal-sync-conflicts" role="status">'+
    message({
      text:(conflicts||[]).length===1
        ?'Jedna zmiana wymaga rozstrzygnięcia przed synchronizacją.'
        :'Zmiany wymagają rozstrzygnięcia przed synchronizacją: '+(conflicts||[]).length+'.',
      kind:'warning'
    })+
    '<ul>'+items+'</ul>'+
    (actions.length?'<div class="actions journal-conflict-actions">'+actions.join('')+'</div>':'')+
    '</section>';
}
